<div class="step-content">
    <div class="header-section">
        <h1 class="page-heading">Confirmation</h1>
    </div>

    <div class="basic-info-section">
        <div class="form-row">
            <form class="dentistInfo-form" [formGroup]="dentistInfoForm">
                <div class="form-group">
                    <app-text-input label="Dentist name" [replaceDoubelQuotes]="true" [for]="'Dentist Name-Input'"
                        [control]="dentistInfoForm.controls['dentistName']" [maxLength]="50">
                    </app-text-input>
                </div>
                <div class="form-group">
                    <app-number-input id="LicenseNumberInput" label="License number" [for]="'License Number-Input'"
                        [control]="dentistInfoForm.controls['licenseNumber']" [fieldType]="'License'">
                    </app-number-input>
                </div>
            </form>
        </div>
    </div>

    <div class="accordion-section">
        <!-- Dentist Demographics -->
        <div class="accordion-item">
            <div class="accordion-header" [ngClass]="{ 'attestations': demographicsErrors.length > 0 }"
                (click)="toggleAccordion('dentistDemographics')">
                <span>Dentist information</span>
                <svg [class.rotated]="accordionStates.dentistDemographics" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" [hidden]="!accordionStates.dentistDemographics">
                @if(demographicsErrors.length > 0){<div class="data-grid">
                    <div *ngFor="let field of demographicsErrors" class="data-item">
                        <div class="documents-list">
                            <div class="doc-item">
                                <span class="label">{{ field.label }}:
                                    <span class="value">
                                        <span>
                                            <span class="requiredValidation">{{ field.error }}</span>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                }@else{
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label">Completed
                            </span>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <!-- Dental Credentials -->
        <div class="accordion-item">
            <div class="accordion-header" [ngClass]="{ 'attestations': isDentalCredentialInvalid }"
                (click)="toggleAccordion('dentalCredentials')">
                <span>Dental credentials</span>
                <svg [class.rotated]="accordionStates.dentalCredentials" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.dentalCredentials">
                @if(credentialsErros?.length > 0){
                <div class="data-grid">
                    <div *ngFor="let field of credentialsErros" class="data-item">
                        <div class="documents-list">
                            <div class="doc-item">
                                <span class="label">{{ field.label }}:
                                    <span class="value">
                                        <span>
                                            <span class="requiredValidation">{{ field.message }}</span>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                }@else{
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label">Completed
                            </span>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <!-- Work History / School Dates -->
        <div class="accordion-item">
            <div class="accordion-header" [ngClass]="{ 'attestations': workHistoryErrors.length > 0 }"
                (click)="toggleAccordion('workHistory')">
                <span>Work/Education history</span>
                <svg [class.rotated]="accordionStates.workHistory" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.workHistory">

                <div *ngIf="workHistoryErrors.length > 0" class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="requiredValidation">
                                {{ workHistoryErrors[0].error }}
                            </span>
                        </div>
                    </div>

                </div>
                <div *ngIf="workHistoryErrors.length === 0">
                    <div class="data-item">
                        <div class="documents-list">
                            <div class="doc-item">
                                <span class="label">Completed
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Attestations -->
        <div class="accordion-item">
            <div class="accordion-header"
                [ngClass]="{ 'attestations':(attestErrors['noRecord'] || attestErrors['inValid']) }"
                (click)="toggleAccordion('attestations')">
                <span>Attestations</span>
                <svg [class.rotated]="accordionStates.attestations" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.attestations">
                @if(attestErrors['noRecord'] || attestErrors['inValid']){<div class="data-grid">
                    <div class="data-item">
                        <div class="documents-list">
                            <span class="label" *ngIf="(attestErrors['noRecord'] || attestErrors['questionFormError'])">
                                <span class="value">
                                    <span>
                                        <span class="requiredValidation">One or more questions have not been answered.
                                            If a question is answered ‘Yes’, an explanation is required.</span>
                                    </span>
                                </span>
                            </span>
                            <span class="label"
                                *ngIf="(attestErrors['noRecord'] || attestErrors['attestationCheckboxError'])">Attestation:
                                <span class="value">
                                    <span>
                                        <span class="requiredValidation">Required</span>
                                    </span>
                                </span>
                            </span>
                            <span class="label" *ngIf="(attestErrors['noRecord'] || attestErrors['fullNameError'])">Full
                                Name:
                                <span class="value">
                                    <span>
                                        <span class="requiredValidation">Required</span>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                }@else{
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label">Completed
                            </span>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <!-- Location -->
        <div class="accordion-item">
            <div class="accordion-header"
                [ngClass]="{ 'attestations': locationErrors.length > 0 || locations.length == 0 || showParLocationError || !ishasPrimaryLocation }"
                (click)="toggleAccordion('location')">
                <span>Locations</span>
                <svg [class.rotated]="accordionStates.location" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.location">
                @if(locationErrors.length > 0){
                @if(locations?.length > 0 && showParLocationError){
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item parPrimeErr">
                            <span class="label requiredValidation">Application submission is not allowed until at least one active
                                location is marked as participating and primary.
                            </span>
                        </div>
                    </div>
                </div>
                }
                <div *ngFor="let loc of locationErrors" class="data-grid">
                    <span class="loc-name">Location - {{ locations[loc.index - 1]?.address1 || locations[loc.index - 1]?.address || locations[loc.index - 1]?.location }}</span>

                    <ng-container *ngFor="let err of loc.errors">
                        <div class="data-item">
                            <div class="documents-list">
                                <div class="doc-item">
                                    <span class="label">{{ err.label }}:
                                        <span class="value">
                                            <span class="requiredValidation">{{ err.error }}</span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                        
                }@else{
                @if(locations?.length == 0){
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label requiredValidation">At least one location entry must be added before
                                submitting your application.
                            </span>
                        </div>
                    </div>
                </div>
                }
                @if(locations?.length > 0 && showParLocationError){
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label requiredValidation">Application submission is not allowed until at least one active location is marked as participating and primary.
                            </span>
                        </div>
                    </div>
                </div>
                }
                @if(locations?.length > 0 && !showParLocationError){
                <div class="data-item">
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="label">Completed
                            </span>
                        </div>
                    </div>
                </div>
                }
                }
            </div>
        </div>

        <!-- Tin -->
        <div class="accordion-item">
            <div class="accordion-header"
                [ngClass]="{ 'attestations':  tinErrors.length > 0 }"
                (click)="toggleAccordion('tin')">
                <span>TIN management</span>
                <svg [class.rotated]="accordionStates.tin" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.tin">
                @if(tinErrors.length > 0){
                <div *ngFor="let tin of tinErrors" class="data-grid">
                    <span class="loc-name">
                        TIN - {{ tin.taxId }}
                    </span>

                    <div *ngFor="let err of tin.errors" class="data-item">
                        <div class="documents-list">
                            <div class="doc-item">
                                <span class="label">
                                    {{ err.label }}:
                                    <span class="value">
                                        <span class="requiredValidation">
                                            {{ err.error }}
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            } @else {
                    <div class="data-item">
                        <div class="documents-list">
                            <div class="doc-item">
                                <span class="label">Completed
                                </span>
                            </div>
                        </div>
                    </div>

            }
            </div>
        </div>

        <!-- Sign Documents -->
        <div class="accordion-item">
            <div class="accordion-header" [ngClass]="{ 'attestations': isSignedDocumentsInvalid }"
                (click)="toggleAccordion('signedDocuments')">
                <span>Documents</span>
                <svg [class.rotated]="accordionStates.signedDocuments" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="accordion-content" *ngIf="accordionStates.signedDocuments">
                <ng-container *ngFor="let doc of signedDocuments">
                    @if (!doc?.hide) {
                    <div class="documents-list">
                        <div class="doc-item">
                            <span class="doc-name"
                                [ngClass]="(doc?.isSigned || doc?.title?.toLocaleLowerCase() == `uniform requirements`) ? 'doc-name-selected' : 'doc-name' "
                                (click)="(doc?.isSigned || doc?.title?.toLocaleLowerCase() == `uniform requirements`) ? 
                                    onViewDocument(doc, doc?.title?.toLocaleLowerCase() == `uniform requirements` ? doc?.name : doc?.originalFileName) : null">
                                {{doc.title }}</span>
                            @if (doc.isSigned) {
                            <span class="doc-date">Signed on: {{ doc.date }}</span>
                            } @else {
                            <span class="doc-date-not-signed">Not signed</span>
                            }
                        </div>
                    </div>
                    }
                </ng-container>
            </div>
        </div>

    </div>


    <app-wizard-navigation [showBack]="true" [showNext]="false" [showFinish]="true" [showPreview]="true"
        (back)="onPrevious()" (finish)="onFinish()" (preview)="openPreview()" (cancel)="onCancel()">
    </app-wizard-navigation>